import { Component, EventEmitter, Output } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import { IconComponent, ButtonComponent } from '@recruitee/user-interface';

import { ReloadNotificationAnalytics } from '../../analytics/reload-notification.analytics';

@Component({
  selector: 'rt-reload-notification',
  templateUrl: './reload-notification.component.html',
  styleUrls: ['./reload-notification.component.less'],
  imports: [ButtonComponent, IconComponent, TranslatePipe],
})
export class ReloadNotificationComponent {
  @Output() public close$ = new EventEmitter<void>();
  @Output() public reload$ = new EventEmitter<void>();

  constructor(public reloadNotificationAnalytics: ReloadNotificationAnalytics) {
    this.reloadNotificationAnalytics.trackComponentActions('show');
  }
}
